<template>
  <div>
    <!-- Loader -->
    <div v-if="isLoading" class="loader">Loading...</div>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit Store</h5>
            <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-for="(store, index) in stores" :key="index" class="mb-3">
              <h5>Store {{ index + 1 }}</h5>
              <button @click="confirmDelete(store.id)" class="btn btn-danger">Delete</button>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Store Name" v-model="stores[index].branchName" required/>
              </div>
              <div class="form-group">
                <input type="number" class="form-control" placeholder="TPIN" v-model="stores[index].tpinNumber" required/>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Physical Address" v-model="stores[index].physicalAddress" required/>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Telephone" v-model="stores[index].Telephone" required/>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="updateStores">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  <div class="container mt-1">

    <div class="card form-card">
      <div class="card-body text-center">

        <img class="m-2" height="100px" src="@/assets/img/screenshot.png">

        <h5 class="card-title mb-2">Smart Invoice Registration Form</h5>
        <h5 class="card-title mb-4">{{ currentTitle }}</h5>

 <!--          - Step 1: Representative Info -->
          <div v-if="step === 1">
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="name" placeholder="Full-names" v-model="businessRepInfo.name" required/>
            </div>
            <div class="form-group mb-1">
              <input type="email" class="form-control" id="tpin" placeholder="Enter TPIN" v-model="businessRepInfo.tpin" required/>
            </div>
            <div class="form-group mb-1">
              <input type="email" class="form-control" id="Email" placeholder="Enter Email address" v-model="businessRepInfo.email" required/>
            </div>
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="position" placeholder="Enter position" v-model="businessRepInfo.position" required/>
            </div>
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="phonenumber" placeholder="Enter Phone Number" v-model="businessRepInfo.contact" required/>
            </div>
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="NRC" placeholder="Enter NRC / Passport No." v-model="businessRepInfo.nrcOrPassport" required/>
            </div>
            <div class="form-group mb-1">
              <textarea class="form-control" id="address" placeholder="Address Details" v-model="businessRepInfo.address" required></textarea>
            </div>
            <div id="app">
              <label>Add signature below and click confirm to proceed</label>
              <vue-signature @setSignature="saveSignature"/>
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-primary" @click="nextStep" :disabled="!isStep1Valid">Next</button>
            </div>
          </div>

          <!-- Step 2: Store Info -->
          <div v-if="step === 2">
            <div class="form-group mb-1">

<!--              <div v-else class="mb-2">-->
<!--                <label for="debtor_name_select" class="fw-bold">Debtor Name / Business Name</label>-->
<!--                <v-select id="debtor_name_select" :reduce="item=>item" :required="!form.name" label="taxPayerName"-->
<!--                          :options="zraList" @input="selectZraDebtor" @search="searchTaxPayers">-->
<!--                  <template slot="no-options">-->
<!--                    <b>Type to search ...</b>-->
<!--                  </template>-->
<!--                </v-select>-->
<!--              </div>-->

              <input type="text" class="form-control" id="store-name" placeholder="Store Name" v-model="branchDetails.branchName" required/>
            </div>
            <div class="form-group mb-1">
              <a class="btn btn-primary btn-sm mx-2" v-if="branchDetails.tpinNumber" @click="checkZRADetails">
                Verify Tpin
              </a>
              <input type="number" class="form-control" id="TPIN" placeholder="TPIN" v-model="branchDetails.tpinNumber" required/>
            </div>
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="PhysicalAddress" placeholder="Physical Address" v-model="branchDetails.physicalAddress" required/>
            </div>
            <div class="form-group mb-1">
              <input type="text" class="form-control" id="Telephone" placeholder="Telephone" v-model="branchDetails.Telephone" required/>
            </div>


            <div class="btn-group">
              <button type="button" class="btn btn-outline-secondary mr-2" @click="previousStep">Previous</button>
              <button type="button" class="btn mr-2" @click="saveStore" style="background-color: #28a745; color: white; border-color: #28a745;" :disabled="!isStoreValid">Add Store</button>
              <button v-if="stores.length > 0" type="button" class="btn btn-danger mr-2" data-bs-toggle="modal" data-bs-target="#exampleModal" >Edit Added Stores</button>
              <!-- Conditional rendering of the Next button -->
              <button v-if="stores.length > 0" type="button" class="btn btn-primary" @click="nextStep">Next</button>
            </div>
          </div>

          <!-- Step 3: Summary -->
          <div v-if="step === 3">
            <div>
              <h2>Representative Info:</h2>
              <p><strong>Name:</strong> {{ businessRepInfo.name }}</p>
              <p><strong>Tpin:</strong> {{ businessRepInfo.tpin }}</p>
              <p><strong>Email:</strong> {{ businessRepInfo.email }}</p>
              <p><strong>Position:</strong> {{ businessRepInfo.position }}</p>
              <p><strong>Phone Number:</strong> {{ businessRepInfo.contact }}</p>
              <p><strong>NRC / Passport No.:</strong> {{ businessRepInfo.nrcOrPassport }}</p>
              <p><strong>Address Details:</strong> {{ businessRepInfo.address }}</p>
            </div>
            <div v-for="(store, index) in stores" :key="index">
              <h2>Store {{ index + 1 }}:</h2>
              <p><strong>Store Name:</strong> {{ store.branchName }}</p>
              <p><strong>Store Tpin:</strong> {{ store.tpinNumber }}</p>
              <p><strong>Store Address:</strong> {{ store.physicalAddress }}</p>
              <p><strong>Store Telephone:</strong> {{ store.Telephone }}</p>
             </div>
            <div class="btn-group">
              <button type="button" class="btn btn-outline-secondary mr-4" @click="previousStep">Previous</button>
              <button type="button" class="btn btn-primary" @click="submitForm">Submit</button>
            </div>
          </div>
       </div>
    </div>
  </div>
  </div>

</template>

<script>
import VueSignature from "@/components/VueSignature";
import axios from "axios";
import {errorHandler} from "@/Services/errorHandler";
import Swal from "sweetalert2";

export default {
  components: { VueSignature },
  created() {
    // Retrieve the saved 'tpinResponse' from localStorage
    const savedResponse = localStorage.getItem('tpinResponse');
    if (savedResponse) {
      this.tpinResponse = JSON.parse(savedResponse);
    }
  },
  beforeMount() {
    // Simulate a loader while checking local storage
    setTimeout(() => {
      const savedData = localStorage.getItem('tpinResponse');
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        this.businessRepInfo = {
          ...this.businessRepInfo,
          name: parsedData.name,
          tpin: parsedData.tpin,
          email: parsedData.email,
          position: parsedData.position,
          contact: parsedData.contact,
          nrcOrPassport: parsedData.nrcOrPassport,
          address: parsedData.address
        };
        this.step = 2; // Skip to step 2
      }
    }, 0.1); // Simulate loading time
  },
  data() {
    return {
      step: 1, // Track the current step in the form
      showZraList : false,
      zraList: [],
      businessRepInfo: {
        name: '',
        email: '',
        position: '',
        contact: '',
        nrcOrPassport: '',
        tpin: '',
        address: ''
      },
      form:{
        name: '',
        tpin: ''
      },
      stores: [], // Array to hold store information
      branchDetails: {
        branchName: '',
        tpinNumber: "",
        Telephone: "",
        physicalAddress: ''
      },
      signature: null // Add this to manage the signature data
    };
  },
  computed: {
    currentTitle() {
      return this.step === 1 ? 'Representative Info' : this.step === 2 ? 'Store Info' : 'Summary';
    },
    isStep1Valid() {
      return this.businessRepInfo.name && this.businessRepInfo.tpin && this.businessRepInfo.email && this.businessRepInfo.position && this.businessRepInfo.contact && this.businessRepInfo.nrcOrPassport && this.businessRepInfo.address && this.signature;
    },
    isStoreValid() {
      return this.branchDetails.branchName && this.branchDetails.tpinNumber && this.branchDetails.physicalAddress && this.branchDetails.Telephone;
    }
  },
  methods: {
    searchTaxPayers(search) {
       return axios.get( franchiseTomcatApi + `zrataxinfo/searchTaxPayer?name=${search}`)
    .then(({ data }) => {
        this.zraList = data;
        return data;
      })
    },
    selectZraDebtor(selected) {
      if (!selected) return;
      this.branchDetails.branchName = selected.taxPayerName;
      this.branchDetails.tpinNumber = selected.tpin;
    },
    checkZRADetails() {
      this.$utils.showLoading();
      return axios.get(franchiseTomcatApi + `AndroidLogin/TPIN/${this.branchDetails.tpinNumber}`)
          .then(({ data }) => {
            if (data.tpin) {
              this.$utils.hideLoading()
              let name = data.taxPayerName;
              this.branchDetails.branchName = name;
              if (name) this.showZraList = false;
              return data;
            } else if (data.toString().includes(`Send TPIN:`)) {
              throw new Error(`Invalid TPIN`);
            }
            this.$utils.hideLoading()
          })
          .catch(err => errorHandler.tomcatError(err))
    },
    confirmDelete(storeId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this entry?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteStore(storeId);
          Swal.fire(
              'Deleted!',
              'The store has been deleted.',
              'success'
          );
        }
      });
    },

    deleteStore(storeId) {
      // Find the index of the store to delete
      const index = this.stores.findIndex(store => store.id === storeId);
      if (index !== -1) {
        // Remove the store from the list
        this.stores.splice(index, 1);

      }

  },
    nextStep() {
      if (this.step === 1 && this.isStep1Valid) {
        this.step = 2; // Move to the store info step
      } else if (this.step === 2 && this.stores.length > 0) {
        this.step = 3; // Move to the summary step
      } else if (this.step === 3) {
        this.submitForm(); // Handle form submission or reset
      }
    },
    previousStep() {
      if (this.step === 3) {
        this.step = 2; // Go back to the store info step
      } else if (this.step === 2) {
        this.step = 1; // Go back to the representative info step
      }
    },
    saveStore() {
      if (this.isStoreValid) {
        this.stores.push({ ...this.branchDetails }); // Save the current store info
        this.branchDetails = { branchName: '', physicalAddress: '', tpinNumber: '', Telephone: '', email: '' }; // Clear input fields
        Swal.fire({
          icon: 'success',
          title: 'Store Added Successfully',
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Store Info',
          text: 'Please fill out all required fields for the store.',
        });
      }
    },
       clearStores() {
        const modal = new bootstrap.Modal(document.getElementById('exampleModal'));
        modal.show();
      },
    updateStores() {
      Swal.fire({
        icon: 'success',
        title: 'Stores Updated Successfully',
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        document.getElementById('close').click();
       });
    },
    async saveSignature(signatureFile) {
      signatureFile = signatureFile.replaceAll("data:image/png;base64,", "");
      this.signature = signatureFile;
    },

    async submitForm() {
      this.$utils.showLoading();

      // Determine the branch details with mainBranch property
      const branchInfo = this.stores.map((store, index) => ({
        contact: store.Telephone,
        storeReference: store.branchName,
        tpinNumber: store.tpinNumber,
        address: store.physicalAddress,
        mainBranch: index === 0
      }));
      let agent = this.$route.params.id;

      // Create the payload
      const payload = {
        directorInfo: {
          email: this.businessRepInfo.email,
          address: this.businessRepInfo.address,
          position: this.businessRepInfo.position,
          contact: this.businessRepInfo.contact,
          name: this.businessRepInfo.name,
          tpin: this.businessRepInfo.tpin,
          nrcOrPassport: this.businessRepInfo.nrcOrPassport,
          signature: this.signature // Assuming this is a base64 string
        },
        branchInfo,
        agent
      };

      try {
        let url = signupStatus + 'signup'
        await this.sendRequest({ url , payload });

        Swal.fire({
          icon: 'success',
          title: 'Form Submitted Successfully',
          text: 'Your information has been saved.',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.$utils.hideLoading();
          return this.$router.push({ name : `Verification`, params : { id : agent  } });
        });
      }catch (err) {

        errorHandler.tomcatError(err);
      } finally {

      }},

    sendRequest({ url, payload }) {
      const maxRetries = 3;
      let currentRetry = 0;
      if (!payload.localid){
        payload.localid = generateUUID();
      }

      const attemptRequest = () => {
        return axios.post(url, payload)
            .then(({ data }) => {
              if (!data.processed) {
                // Check if the response indicates unprocessed data and if retries are available
                if (currentRetry < maxRetries) {
                  currentRetry++;
                  console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                  return attemptRequest(); // Retry the request
                }
                // Throw an error if max retries are reached with unprocessed data
                throw new Error('Data still unprocessed after maximum retries : '+maxRetries);
              }
              return data.response; // Return the response if data is processed
            }).catch(err => {
              if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                if (currentRetry < maxRetries) {
                  currentRetry++;
                  console.log(`Attempt ${currentRetry}: Retrying...`);
                  return attemptRequest(); // Retry the request
                }
              }
              throw err; // Re-throw the error if it's not a timeout or retries are exhausted
            });
      };
      return attemptRequest()
          .then(response => response)
          .catch(err => errorHandler.tomcatError(err));
    },
    resetForm() {
      this.step = 1;
      this.businessRepInfo = { name: '', email: '', position: '', contact: '', nrcOrPassport: '', address: '' };
      this.stores = [];
      this.branchDetails = { branchName: '', physicalAddress: '', tpinNumber: '', Telephone: '', email: '' };
      this.signature = '';
    }
  }
};
</script>

<style scoped>
html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
}

.form-card {
  max-width: 500px;
  width: 100%;
  margin: 30px auto 0; /* Center the card horizontally and add top margin */
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-body {
  padding: 30px;
}

.card-title {
  font-weight: bold;
}
.loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}
@media (max-width: 768px) {
  .card-body {
    padding: 20px;
  }
}

@media (max-width: 576px) {
  .card-body {
    padding: 15px;
  }

  .form-group {
    margin-bottom: 10px;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
  }

  .btn-group .btn {
    margin: 0 5px;
  }
  .btn {
    font-size: 14px;
  }
}
</style>
